import { createGlobalStyle } from "styled-components";
import RetroGamingWoff from "./RetroGaming/RetroGaming.woff";
import RetroGamingWoff2 from "./RetroGaming/RetroGaming.woff2";

const FontStyles = createGlobalStyle`
    @font-face {
        font-family: 'RetroGaming';
        src: url(${RetroGamingWoff2}) format('woff2'),
            url(${RetroGamingWoff}) format('woff');
    }
`;

export default FontStyles; 
